import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between pt-3" }
const _hoisted_3 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Role Details ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-2" }, null, -1)
const _hoisted_6 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_7 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Permissions")
const _hoisted_9 = { class: "w-full rounded-md border-[1px] border-grey300 px-4 py-4 grid-cols-12 grid gap-4" }
const _hoisted_10 = { class: "w-full flex flex-col space-y-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_icon = _resolveComponent("roof-icon")!
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_page_data = _resolveComponent("roof-page-data")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_checkbox = _resolveComponent("roof-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "w-[38px] h-[38px] cursor-pointer rounded-full border-[1px] border-gray-grey300 flex flex-row items-center justify-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Logic.Common.goBack()))
        }, [
          _createVNode(_component_roof_icon, {
            customClass: 'h-[20px]',
            name: 'chevron-left'
          })
        ]),
        _createVNode(_component_roof_header_text, { "custom-class": '!text-2xl' }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    _createVNode(_component_roof_page_data, { data: _ctx.pageData }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionCategotries, (permission, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mdlg:!col-span-3 md:!col-span-6 col-span-full flex flex-col space-y-4",
            key: index
          }, [
            _createVNode(_component_roof_normal_text, { customClass: '!font-semibold' }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(permission.name), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.permissionData, (item, index) => {
                return (_openBlock(), _createBlock(_component_roof_checkbox, {
                  key: index,
                  modelValue: item.status,
                  "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                  defaultValue: item.status,
                  onClick: ($event: any) => (_ctx.permissionChanged(item))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.capitalize(item.name)), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "defaultValue", "onClick"]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}